import jQuery from "jquery";
import MicroModal from "micromodal";

import createModal from "./create_modal";

const $ = jQuery;

export default function (evaluationUrl) {
  $(() => {
    const id = "video-sets_evaluation-modal";
    const popUp = $(
      createModal(
        id,
        "Wie gefallen dir unsere M3-Prüfungsvideos?",
        "Nimm dir doch bitte 3 Minuten Zeit, um unseren Feedbackbogen zu den M3-Prüfungsvideos auszufüllen und damit zur Verbesserung dieses Angebots beizutragen. Du kannst den Bogen auch zu einem späteren Zeitpunkt ausfüllen.<p><strong>Möchtest du den Feedbackbogen jetzt ausfüllen?</strong></p>",
        "Zum Feedbackbogen",
        "Jetzt nicht"
      )
    );
    const primaryButton = popUp.find(".modal__btn-primary");

    $(document.body).append(popUp);

    MicroModal.init();
    MicroModal.show(id, {
      onClose: () => {
        primaryButton.off(`click.${id}`)
      },
    });
    primaryButton.one(`click.${id}`, () => {
      MicroModal.close(id);
      
      const newTab = window.open('', '_blank');
      newTab.opener = null;
      newTab.location = evaluationUrl;
      newTab.focus();
    });
  });
}
